import gql from 'graphql-tag'

export const resourceFragment = gql`
    fragment resourceFragment on Resource{
        id
        name
        description
        ignore_tracking
        applyTo
        isUserVehicule
        deleted_at
        customOrder
        userProfile {
            id
            name
        }
    }
`
export const staffVehiculeFragment = gql`
    fragment staffVehiculeFragment on StaffVehicule{
        id
        name
        description
        ignore_tracking
        applyTo
        isUserVehicule
        customOrder
        userProfile {
            id
            name
        }
    }
`

export const resourceTypeFragment = gql`
    fragment resourceTypeFragment on ResourceType{
        id
        name
        label
        color
        deleted_at
    }
`